import { useNavigate } from "react-router-dom";
import { errorNotifier } from "../../..";
import http, { AUTH_ROUTES } from "../../../service/api";

export const _register = async (payload, next, setLoading) => {
  try {
    const result = await http.post(AUTH_ROUTES.REGISTER, payload);
    return result
    setLoading(false);
  } catch (e) {
    errorNotifier(e.response?.data?.message);
    setLoading(false);
  }
};

export const getOcccupations = async () => {
  try {
    const result = await http.get(AUTH_ROUTES.GET_OCCUPATIONS);
    return result
  } catch (e) {
    errorNotifier(e.response?.data?.message);
  }
};

export const enterOTP = async (payload, next, setLoading) => {
  try {
    const result = await http.post(AUTH_ROUTES.VERIFY_EMAIL, payload);
    const token = result?.data?.token;
    sessionStorage.setItem("#f8WEB#", token);
    return result
    setLoading(false);
  } catch (e) {
    errorNotifier(e.response?.data?.message);
    setLoading(false);
  }
};

export const createUserBio = async (payload, next) => {
  try {
    const token = sessionStorage.getItem("#f8WEB#");
    console.log('token',token);
    const headers = {
      Authorization: `Bearer ${token}`,
      // Other headers if needed
    };
    const result = await http.post(AUTH_ROUTES.PERSONAL_INFORMATION, payload,{headers});
    return result
  } catch (e) {
    errorNotifier(e.response?.data?.message);
  }
};

export const createAccount = async (payload, next, setLoading) => {
  try {
    const token = sessionStorage.getItem("#f8WEB#");
    console.log('token',token);
    const headers = {
      Authorization: `Bearer ${token}`,
      // Other headers if needed
    };
    const result = await http.post(AUTH_ROUTES.CREATE_ACCOUNT, payload,{headers});
    return result
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

export const createInterests = async (payload, next, setLoading) => {
  const token = sessionStorage.getItem("#f8WEB#");
  console.log('token',token);
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };
  return http.post(AUTH_ROUTES.CREATE_INTEREST, payload,{headers});
};

export const sendFirebaseIdToBackend = async (payload) => {
  return await http.post(AUTH_ROUTES.SEND_FIREBASE_ID, payload);
};

export const loginUser = async (payload) => {
  return http.post(AUTH_ROUTES.LOGIN, payload);
};

export const forgotPassword = async (payload) => {
  return http.post(AUTH_ROUTES.FORGOT_PASSWORD, payload);
};
export const resetPassword = async (payload) => {
  return http.post(AUTH_ROUTES.RESET_PASSWORD, payload);
};

export const sendGoogleAccessToken = async (payload) => {
  return http.post(AUTH_ROUTES.GOOGLE_AUTH, payload);
};
